/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { AiAgentV2ControllerCancelRequestMutationResponse, AiAgentV2ControllerCancelRequestPathParams } from "../../models/aiAgentV2Controller/AiAgentV2ControllerCancelRequest";

function getAiAgentV2ControllerCancelRequestUrl(requestId: AiAgentV2ControllerCancelRequestPathParams["requestId"]) {
  const res = { method: 'POST', url: `/api/v1/ai-agent-v2/cancel/${requestId}` as const }  
  return res
}

/**
 * @summary Cancel a running chat request
 * {@link /api/v1/ai-agent-v2/cancel/:requestId}
 */
export async function aiAgentV2ControllerCancelRequest(requestId: AiAgentV2ControllerCancelRequestPathParams["requestId"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<AiAgentV2ControllerCancelRequestMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getAiAgentV2ControllerCancelRequestUrl(requestId).url.toString(), ... requestConfig })  
  return res.data
}